import { render, staticRenderFns } from "./SimulatedDispatchedOrder.vue?vue&type=template&id=629a8ef6&scoped=true"
import script from "./SimulatedDispatchedOrder.vue?vue&type=script&lang=js"
export * from "./SimulatedDispatchedOrder.vue?vue&type=script&lang=js"
import style0 from "./SimulatedDispatchedOrder.vue?vue&type=style&index=0&id=629a8ef6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629a8ef6",
  null
  
)

export default component.exports